import React, { FC } from 'react';
import { ErrorBanner } from './ErrorBanner';
import { WarningBanner } from './WarningBanner';
import { InfoBanner } from './InfoBanner';
import clsx from 'clsx';
import styles from 'components/CartBanners.module.scss';
import { useSubmitOrder } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';
import { useGetUnavailableItems } from 'hooks/useGetUnavailableItems';

type CartBannersProps = {
  onClick?: () => void;
  gutters?: 'horizontal' | 'vertical' | 'all';
};

export const CartBanners: FC<CartBannersProps> = ({ onClick, gutters }) => {
  const { error: submitOrderError } = useSubmitOrder();
  const { hasUnavailableItems: eightySixthError } = useGetUnavailableItems();

  if (submitOrderError || eightySixthError) {

    return (
      <div className={clsx(styles.bannerGroup, gutters && styles[gutters])}>
        <ErrorBanner />
      </div>
    );
  }

  return (
    <>
      <div className={clsx(styles.bannerGroup, gutters && styles[gutters])}>
        <InfoBanner onClick={onClick} />
      </div>
      <div className={clsx(styles.bannerGroup, styles.warningBanner, gutters && styles[gutters])}>
        <WarningBanner onClick={onClick} />
      </div>
    </>
  );
};
